import categoryType from '@/utils/constants/stipulation78CategoryType';

export default Object.freeze([
  {
    id: 1,
    name: categoryType.CONCILIATION_AGREEMENT,
  },
  {
    id: 2,
    name: categoryType.MEDIATION_AGREEMENT,
  },
  {
    id: 3,
    name: categoryType.JUDGE_ORDER,
  },
]);
